<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="custgrp_id" [(ttModel)]="menu.custgrp_id" ttReadonly></tt-input>
        <tt-input ttLabel="custgrp_name" [(ttModel)]="menu.custgrp_name" [ttButtons]="customerGroupNameButtons" ttReadonly></tt-input>
        <tt-input ttLabel="discgrpcust_name" [(ttModel)]="menu.discgrpcust_name" ttReadonly></tt-input>
        <tt-button-goto *ngIf="menu.custgrp_id !== '0'" [ttText]="'custgrpmenu_edit'" [ttGoto]="'custgrp'" [ttGotoParms]="{ custgrp_id: menu.custgrp_id }"></tt-button-goto>
        <tt-button-goto [ttText]="'custgrpmenu_edisetup'" [ttGoto]="'edisetup'" [ttGotoParms]="{ argtype: 'custgrp_id', argvalue: menu.custgrp_id }"></tt-button-goto>
        <tt-button ttText="custgrpmenu_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
